import React from 'react'
import ReactDOM from 'react-dom'

import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { grey, red } from '@material-ui/core/colors'
import SurfEventRecordingsPlayerV2 from 'cloud-utils/ReactComponents/Components/SurfEventRecordingsPlayer/SurfEventRecordingsPlayerV2'

angular.module('common.directives').directive('eventRecordingsPlayer', [
  '$localStorage',
  '$filter',
  function ($localStorage, $filter) {
    return {
      scope: {
        device: '=',
        event: '=',
        configOptions: '=',
        closePlayer: '&',
        onNoRecordings: '&'
      },
      template: '<div class="custom-element"></div>',
      link: ($scope, $element) => {
        const surfsightConfig = {
          palette: {
            primary: {
              main: grey[900]
            },
            info: {
              main: red[500]
            },
            type: 'dark'
          }
        }

        // todo: SurfSightTeam - upgrade cloud-utils file SurfEventRecordingsPlayer.js:
        //  line 58 - const { uri: serialNumber } = device to imei - needed after migration to APi v2
        //    temp fix below - device={{ uri: $scope.device.imei, ...$scope.device }}
        const theme = createMuiTheme(surfsightConfig)
        ReactDOM.render(
          <ThemeProvider theme={theme}>
            <SurfEventRecordingsPlayerV2
              device={{ uri: $scope.device.imei, ...$scope.device }}
              event={$scope.event}
              services={{
                getUserToken: () => $localStorage.userToken,
                getMediaToken: () => $localStorage.userMediaAccessToken,
                getRecordingStreamQualities: () =>
                  window.recordingStreamQualities,
                translate: $filter('translate')
              }}
              baseUrls={{
                MEDIACORE_BASEURL,
                EDGE_BASEURL,
                V2_BASEURL
              }}
              closePlayer={() => {
                $scope.closePlayer && $scope.closePlayer()
              }}
              configOptions={{
                ...$scope.configOptions
              }}
              onNoRecordings={() =>
                $scope.onNoRecordings && $scope.onNoRecordings()
              }
            />
          </ThemeProvider>,
          $element[0]
        )
        $scope.$on('$destroy', () => {
          ReactDOM.unmountComponentAtNode($element[0])
        })
      }
    }
  }
])
